import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs';
import { BuildingService } from '../../../core/services';
import { TableViewComponentBase, TableViewFilter, filterModes } from '../table-view/table-view-component-base';

export type ModalIntialState = {
  title: string;
  filter: TableViewFilter;
}

export const showTableFilterDetailModal = async (table: TableViewComponentBase<any>, initialState: ModalIntialState, modalClass='modal-lg') => 
  showFilterDetailModal(table.modalService,initialState,modalClass);

export const showFilterDetailModal = async (modalService: BsModalService, initialState: ModalIntialState, modalClass='modal-lg') => {
  const modalRef = FilterDetailModalComponent.show(modalService, initialState, modalClass);
  await firstValueFrom(modalRef.onHidden);
  return { 
    cancelled: modalRef.content.bCancelled,
    editedFilter: modalRef.content.formFilter
   };
}


@Component({
  selector: 'filter-detail-modal',
  templateUrl: './filter-detail-modal.component.html',
})
export class FilterDetailModalComponent implements OnInit {  
  
  static show( modalService: BsModalService, initialState: ModalIntialState, modalClass: string )  {
    return modalService.show(FilterDetailModalComponent, {
      ignoreBackdropClick: true,
      initialState,
      class: modalClass,
    });  
  }

  @Input() title = "";
  @Input() filter: TableViewFilter;
  formFilter: TableViewFilter;
  @Output() filterKeyUp = new EventEmitter<{event:KeyboardEvent,filter:TableViewFilter}>()
  filterModes = filterModes;

  bCancelled = true;
  constructor(
    public buildingService: BuildingService,
    public bsModalRef: BsModalRef
  ) {}

  
  ngOnInit(): void {
    this.formFilter = this.filter ? Object.assign({},this.filter) : null;
  }

  onColumnStateChanged(){
    console.log('onColumnStateChanged()');
  }

  onFilterModeChanged(){
    console.log('onFilterModeChanged()');
  }
  
  clear() {
    this.bCancelled = false;
    this.bsModalRef.hide()
  }

  ok() {
    this.bCancelled = false;
    //this.filter.value = this.formFilter.value;
    //this.filter.mode = this.formFilter.mode;
    this.bsModalRef.hide()
  }

  cancel() {
    this.bCancelled = true;
    this.bsModalRef.hide()
  }
}